"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneNumberValidationSchema = void 0;
const yup_1 = require("yup");
exports.phoneNumberValidationSchema = (0, yup_1.string)().required("form.validations.valueMissing");
//# sourceMappingURL=phone-number.js.map